import * as React from "react"

const BoxDoorPortal = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 232.9 244.5" {...props}>
    <title>{"home-1-box-door-portal-outlines-2"}</title>
    <path
      d="M107.1 244.5V61.9L146.6 0v182.6Zm9-180v149l21.5-33.6v-149Z"
      fill="#3e4c5e"
    />
    <path fill="#4ead90" d="m232.9 120.9-22.3 38.5h-44.5l22.3-38.5h44.5z" />
    <path fill="#317d6e" d="M166.1 82.4h44.5l22.3 38.5h-44.5l-22.3-38.5z" />
    <path
      fill="#b9d816"
      d="M166.2 82.4 144 120.9l22.2 38.5 22.2-38.5-22.2-38.5z"
    />
    <path fill="#4ead90" d="m160.9 120.9-22.3 38.5H94.1l22.3-38.5h44.5z" />
    <path fill="#317d6e" d="M94.1 82.4h44.5l22.3 38.5h-44.5L94.1 82.4z" />
    <path
      fill="#b9d816"
      d="M94.2 82.4 72 120.9l22.2 38.5 22.2-38.5-22.2-38.5z"
    />
    <path fill="#4ead90" d="m88.8 120.9-22.2 38.5H22.1l22.3-38.5h44.4z" />
    <path fill="#317d6e" d="M22.1 82.4h44.5l22.2 38.5H44.4L22.1 82.4z" />
    <path
      fill="#b9d816"
      d="M22.2 82.4 0 120.9l22.2 38.5 22.2-38.5-22.2-38.5z"
    />
    <path
      fill="#3e4c5e"
      d="M107.1 244.5V61.9L138.3 13l7.6 4.9-29.8 46.6v149l22.2-34.7 7.6 4.9-38.8 60.8z"
    />
  </svg>
)

export default BoxDoorPortal
